/* eslint-disable import/prefer-default-export */

const ACCENT_GREEN_500 = '#00b268';

export { ACCENT_GREEN_500 };
